import Image from "next/image"

export function Logo() {
  return (
    <div className="h-10 w-10 relative">
      <Image
        src="/images/thehiitpit-logo-light.svg"
        alt="The HIIT PIT Logo Light"
        width={40}
        height={40}
        className="object-contain light-logo logo"
        priority
      />
      <Image
        src="/images/thehiitpit-logo.svg"
        alt="The HIIT PIT Logo Dark"
        width={40}
        height={40}
        className="object-contain dark-logo logo"
      />
    </div>
  )
}

